import './_dashboardItemWrapper.scss';

import * as React from 'react';

type Props = {
    children: React.ReactNode;
    dataTitle: string;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
    itemStyle?: React.CSSProperties;
};

/**
 * DashboardItemWrapper is a wrapper components that is only defined by his style.
 * There is no business logic.
 */

function DashboardItemWrapper({
    dataTitle,
    onClick = () => {},
    itemStyle = {},
    children,
}: Props): React.ReactElement {
    return (
        <div
            className="dashboard-group"
            data-e2e-title={dataTitle}
            data-testid={`dashboard-item ${dataTitle}`}
            onClick={onClick}
        >
            <div className="dashboard-item" style={itemStyle}>
                {children}
            </div>
        </div>
    );
}
export default DashboardItemWrapper;
